import React, { useEffect, useState } from 'react';
import { MainBar } from '@components/MainBar';
import { useStyles } from './styles/BasePage.styles';
import { useSelector } from 'react-redux';
import { AppRoutes } from '@consts/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { isTokenExpired } from '@utils/helper';
import { logout } from '@features/redux/store';
import { refreshToken } from '@api/user';
import { LoadingScreen } from '@components/LoadingScreen';

import type { RootState } from '@features/redux/store';
import { checkPathHasPermission } from '@utils/permissions';

interface BasePageProps {
    children: React.ReactNode;
}

export const BasePage = ({ children }: BasePageProps) => {
    const navigate = useNavigate();

    const classes = useStyles();

    const [tokenChecked, setTokenChecked] = useState(false);

    const {
        IdToken,
        RefreshToken,
        Persist,
        Roles: { role },
    } = useSelector((state: RootState) => state.auth);

    const { pathname } = useLocation();

    useEffect(() => {
        if (!IdToken) {
            navigate(AppRoutes.Login);
        }
    }, [IdToken]);

    useEffect(() => {
        if (!checkPathHasPermission(role, pathname as AppRoutes)) {
            navigate(pathname === AppRoutes.Insights ? AppRoutes.Login : AppRoutes.Insights);
        }
    }, [pathname, role]);

    useEffect(() => {
        const expired = isTokenExpired(IdToken);
        if (expired && Persist) {
            refreshToken(RefreshToken as string);
        } else if (expired) {
            logout();
        } else {
            setTokenChecked(true);
        }
    }, [IdToken]);

    return tokenChecked && IdToken ? (
        <div className={classes.root}>
            <MainBar />

            {children}
        </div>
    ) : (
        <LoadingScreen active={true} />
    );
};
